module.exports = __webpack_public_path__ + "img/tarj2-9.307e31c8.svg";